import request from "./request";
import { filterUndefindObj } from '@src/utils/dataHandlingFunc';

// 获取用户信息
export const getUserInfo = async (id) => {
  const res = await request({
    method: 'get',
    url: '/admin_user/operator_user',
    data: {
      user_id: id
    }
  });

  return {
    userId: res?.id ?? 0,
    accountId: res?.account_id ?? 0,
    colorMode: res?.color_mode ?? 0,
    creationDate: res?.creation_date ?? '',
    description: res?.description ?? '',
    email: res?.email ?? '',
    enabled2FA: res?.enabled_2FA ?? 0,
    expiryDate: res?.expiry_date ?? '',
    image: res?.image ?? '',
    isVerified: res?.isVerified ?? '',
    isAdmin: res?.is_admin ?? '',
    isSendMail: res?.is_send_mail ?? '',
    isSuperAdmin: res?.is_super_admin ?? 0,
    language: res?.language ?? 'en_US',
    lastLoginDate: res?.last_login_date ?? '',
    lastLoginTime: res?.last_login_time ?? '',
    lastLoginIp: res?.last_login_ip ?? '',
    loginTime: res?.login_time ?? '',
    locale: res?.locale ?? '',
    timeZone: res?.timezone ?? '',
    name: res?.username ?? ''
  }
};

// 修改用户信息
export const editUserInfo = async ({
  id,
  name,
  file,
  timeZone,
  local,
  password,
  newEmail,
  code
}) => {
  const newparams = filterUndefindObj({
    user_id: id,
    name,
    pictures: file,
    time_zone_n: timeZone ? Number(timeZone) : undefined,
    time_zone: local,
    pwd: password,
    email: newEmail,
    v_code: code
  });

  const formData = new FormData();
  Object.keys(newparams).forEach(item => {
    formData.append(item, newparams[item]);
  })

  const res = await request({
    method: 'put',
    url: '/admin_user/operator_user',
    propsType: 'custom',
    data: formData
  });

  return !!res;
};


// 获取邮箱验证码
export const getEmailCode = async (id) => {
  const res = await request({
    method: 'post',
    url: '/admin_user/reset_password/send_email',
    data: {
      user_id: id
    }
  });

  return !!res;
};
